





































import {
  computed,
  defineComponent,
  PropType,
  ref,
  toRefs
} from '~/utils/nuxt3-migration'
import { OfferActions, OfferState } from '~/models/classified/offers'
import CConfirmationModal from '~/components/shared/configurable/modal/CConfirmationModal.vue'
import { ciTimes } from '~/icons/source/regular/times'
import { useI18n } from '~/compositions/i18n'
import { ciOffers } from '~/icons/source/regular/offers'

export default defineComponent({
  components: { CConfirmationModal },
  props: {
    actionType: {
      type: String as PropType<OfferActions>,
      required: true
    },
    rightButton: {
      type: Boolean,
      required: false,
      default: false
    },
    title: {
      type: String,
      required: false,
      default: ''
    },
    outline: {
      type: Boolean,
      required: false,
      default: true
    },
    isCounteroffer: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(props, { emit }) {
    const { actionType, rightButton, isCounteroffer } = toRefs(props)
    const showConfirmModal = ref(false)
    const confirmAction = ref<OfferActions | null>(null)
    const { t } = useI18n()

    const onActionClick = () => {
      if ([OfferActions.COUNTER, OfferActions.NEW].includes(actionType.value)) {
        emit('click')
        return
      }

      confirmAction.value = actionType.value
      showConfirmModal.value = true
    }
    const onConfirm = () => {
      let state
      switch (confirmAction.value) {
        case OfferActions.REJECT:
          state = OfferState.REJECTED
          break
        case OfferActions.CANCEL:
          state = OfferState.WITHDRAWN
          break
        case OfferActions.ACCEPT:
          state = OfferState.ACCEPTED
          break
      }

      emit('state-confirmed', state)
    }
    const confirmModalInfo = computed(() => {
      switch (confirmAction.value) {
        case OfferActions.REJECT:
          return {
            title: t('reject {offertype}', {
              offertype: isCounteroffer.value
                ? t('counteroffer::antiprosforas').toLowerCase()
                : t('offer::prosforas').toLowerCase()
            }),
            okText: t('reject {offertype}', {
              offertype: isCounteroffer.value
                ? t('counteroffer::antiprosforas').toLowerCase()
                : t('offer::prosforas').toLowerCase()
            }),
            okVariant: 'danger',
            bodyText: t('are you sure you want to reject this {offertype}?', {
              offertype: isCounteroffer.value
                ? t('counteroffer').toLowerCase()
                : t('offer::prosfora').toLowerCase()
            })
          }
        case OfferActions.CANCEL:
          return {
            title: t('cancel {offertype}', {
              offertype: isCounteroffer.value
                ? t('counteroffer::antiprosforas').toLowerCase()
                : t('offer::prosforas').toLowerCase()
            }),
            okText: t('cancel {offertype}', {
              offertype: isCounteroffer.value
                ? t('counteroffer::antiprosforas').toLowerCase()
                : t('offer::prosforas').toLowerCase()
            }),
            okVariant: 'danger',
            bodyText: t('are you sure you want to cancel this {offertype}?', {
              offertype: isCounteroffer.value
                ? t('counteroffer').toLowerCase()
                : t('offer::prosfora').toLowerCase()
            })
          }
        case OfferActions.ACCEPT:
          return {
            title: t('accept {offertype}', {
              offertype: isCounteroffer.value
                ? t('counteroffer::antiprosforas').toLowerCase()
                : t('offer::prosforas').toLowerCase()
            }),
            okText: t('accept {offertype}', {
              offertype: isCounteroffer.value
                ? t('counteroffer::antiprosforas').toLowerCase()
                : t('offer::prosforas').toLowerCase()
            }),
            okVariant: 'success',
            bodyText: t('are you sure you want to accept this {offertype}?', {
              offertype: isCounteroffer.value
                ? t('counteroffer').toLowerCase()
                : t('offer::prosfora').toLowerCase()
            })
          }
        default:
          return null
      }
    })

    const btnIcon = computed(() => {
      if (rightButton.value) {
        switch (actionType.value) {
          case OfferActions.REJECT:
          case OfferActions.CANCEL:
            return ciTimes
          case OfferActions.COUNTER:
          case OfferActions.NEW:
            return ciOffers
          default:
            return null
        }
      }
      return null
    })

    const actionTitle = computed(() => {
      switch (actionType.value) {
        case OfferActions.ACCEPT:
          return t('accept::prosfora')
        case OfferActions.NEW:
          return t('make a new offer')
        case OfferActions.COUNTER:
          return t('counteroffer')
        case OfferActions.REJECT:
          return t('reject::prosfora')
        case OfferActions.CANCEL:
          return t('cancel')
        default:
          return ''
      }
    })

    const btnVariant = computed(() => {
      if (!rightButton.value) {
        switch (actionType.value) {
          case OfferActions.ACCEPT:
            return 'success'
          case OfferActions.COUNTER:
            return 'tbi'
          case OfferActions.NEW:
            return 'secondary'
          case OfferActions.REJECT:
          case OfferActions.CANCEL:
            return 'danger'
          default:
            return undefined
        }
      }
      return undefined
    })

    const rightButtonClasses = computed(() => {
      if (rightButton.value) {
        switch (actionType.value) {
          case OfferActions.REJECT:
          case OfferActions.CANCEL:
            return 'tw-bg-grey-50 tw-text-grey-400 hover:!tw-bg-red-500 hover:!tw-text-white'
          case OfferActions.COUNTER:
            return 'tw-bg-amber-800 hover:tw-bg-amber-700 tw-text-white'
          case OfferActions.NEW:
            return 'tw-bg-blue-800 hover:tw-bg-blue-700 tw-text-white'
          default:
            return ''
        }
      }
      return ''
    })

    return {
      onActionClick,
      onConfirm,
      confirmModalInfo,
      ciTimes,
      ciOffers,
      btnIcon,
      actionTitle,
      rightButtonClasses,
      btnVariant,
      showConfirmModal
    }
  }
})
